import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Briefcase, Star, Timer, Camera } from "lucide-react";

export default function BusinessStats({ refreshKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/gigs/business/stats").then((r) => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s) return null;
  const max = Math.max(1, ...s.months.map((m) => m.spend));
  const K = ({ icon: I, label, value, sub, tid }) => (
    <div className="p-3 rounded-xl bg-slate-900/60 border border-slate-800" data-testid={tid}>
      <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500 flex items-center gap-1"><I className="w-3 h-3" />{label}</p>
      <p className="font-display font-extrabold text-xl mt-0.5">{value}</p>
      {sub && <p className="text-[11px] text-slate-500">{sub}</p>}
    </div>
  );
  return (
    <div className="p-5 rounded-2xl bg-[#131722] border border-slate-800 space-y-4" data-testid="business-stats">
      <div className="flex items-center justify-between">
        <p className="text-xs font-mono uppercase tracking-widest text-cyan-400 flex items-center gap-1.5"><Briefcase className="w-3.5 h-3.5" />Business dashboard</p>
        <p className="text-xs text-slate-500">{s.completed} completed · {s.active} active</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <K icon={Briefcase} label="This month" value={`$${s.this_month_spend.toFixed(2)}`} sub={`${s.this_month_jobs} jobs · $${s.lifetime_spend.toFixed(0)} lifetime`} tid="bs-spend" />
        <K icon={Star} label="Avg driver rating" value={s.avg_driver_rating != null ? `${s.avg_driver_rating.toFixed(1)}★` : "—"} sub={`${s.ratings_given} ratings given`} tid="bs-rating" />
        <K icon={Timer} label="On-time rate" value={s.on_time_rate != null ? `${s.on_time_rate}%` : "—"} sub="picked up within window" tid="bs-ontime" />
        <K icon={Camera} label="Proof photos" value={s.proof_photos} sub="deliveries with photo" tid="bs-proof" />
      </div>
      <div className="flex items-end gap-2 h-20" data-testid="bs-chart">
        {s.months.map((m) => (
          <div key={m.month} className="flex-1 flex flex-col items-center gap-1">
            <div className="w-full rounded-t bg-gradient-to-t from-blue-500 to-cyan-400 transition-all" style={{ height: `${Math.max(4, (m.spend / max) * 56)}px` }} title={`$${m.spend}`} />
            <span className="text-[9px] font-mono text-slate-500">{m.month.slice(5)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
